import { queryOptions } from '@tanstack/vue-query';
import { PriorityQueryKey } from '@/modules/common/enums/query-key.enum.ts';
import { RegionApi } from '@/modules/counterparty/api/region.api.ts';

export class RegionQueryOptions {
  static BASE_KEY = 'region';

  static getList(signal?: AbortSignal) {
    return queryOptions({
      queryKey: [PriorityQueryKey.Secondary, RegionQueryOptions.BASE_KEY],
      queryFn: (meta) => RegionApi.getList(signal ?? meta.signal),
    });
  }
}
